import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled, { css } from 'styled-components';
import { f as focusOutline } from '../../theme/style-mixins/FocusIndicator/focusOutline-oDdaDZ4N.js';
import { i as isMobile } from '../../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { a as TaktIdConsumer } from '../../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { K as KEYBOARD_KEYNAMES } from '../../LocalModules/storm-ui-utils/dist/esm/keyboardKeynames-CVa_vjg3-CVa_vjg3.js';
import { b as angleInlineEnd } from '../../LocalModules/storm-ui-icons/dist/esm/localIcons-9_jhfe7X-DyCR5FH7.js';
import { C as Checkbox } from '../../Checkbox/Checkbox-CNKyPcOf.js';
import { I as Icon } from '../../Icon/Icon-Cgh13Jz2.js';

const Container = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40025937__sc-1uptxev-0"
})(["display:flex;flex-direction:row;padding-inline:", ";padding-block:", ";:not(:last-child){border-block-end:", ";}", ""], ({
  theme
}) => theme.spacing.xxsmall.default, ({
  theme
}) => theme.spacing.xxsmall.default, ({
  $isSelected,
  theme
}) => $isSelected ? theme.selectableContainer.border.selected : theme.selectableContainer.border.default, isMobile(css(["padding-inline:", ";padding-block:", ";"], ({
  theme
}) => theme.spacing.xxsmall.mobile, ({
  theme
}) => theme.spacing.xxsmall.mobile)));
const ClickableContainer = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40025937__sc-1uptxev-1"
})(["all:unset;flex:1;display:flex;align-items:center;", " :focus-visible{border-radius:", ";outline:none;", "}"], ({
  $isClickable
}) => $isClickable && {
  cursor: 'pointer'
}, ({
  theme
}) => theme.border.radius.medium, focusOutline);
const CenterColumn = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40025937__sc-1uptxev-2"
})(["flex-grow:1;"]);
const PositionedCheckbox = /*#__PURE__*/styled(Checkbox).withConfig({
  componentId: "sc-storm-ui-40025937__sc-1uptxev-3"
})(["margin-inline-end:", ";align-self:start;"], ({
  theme
}) => theme.controls.paddingInline.xlarge.default);
const StyledIcon = /*#__PURE__*/styled(Icon).withConfig({
  componentId: "sc-storm-ui-40025937__sc-1uptxev-4"
})(["color:", ";:focus-visible{", "}"], ({
  theme
}) => theme.text.color.default, focusOutline);
const getClickableContainerAs = ({
  href,
  onClick
}) => {
  if (typeof href === 'string') {
    return 'a';
  }
  if (typeof onClick === 'function') {
    return 'button';
  }
  return 'div';
};
const Content = ({
  href,
  id,
  isSelected = false,
  onSelect,
  onClick,
  ariaLabel,
  children,
  ...restProps
}) => {
  const isClickable = typeof href === 'string' || typeof onClick === 'function';
  const handleSelect = event => {
    onSelect === null || onSelect === void 0 || onSelect(event);
  };
  return /*#__PURE__*/React__default.createElement(TaktIdConsumer, null, ({
    getDataTaktAttributes
  }) => /*#__PURE__*/React__default.createElement(Container, {
    $isSelected: isSelected
  }, onSelect && /*#__PURE__*/React__default.createElement(PositionedCheckbox, _extends({}, getDataTaktAttributes({
    taktIdSuffix: `${id}_checkbox`
  }), {
    id: `${id}_checkbox`,
    label: ariaLabel,
    hideLabel: true,
    checked: isSelected,
    size: "large",
    onChange: handleSelect,
    onKeyUp: event => event.key === KEYBOARD_KEYNAMES.ENTER && (onSelect === null || onSelect === void 0 ? void 0 : onSelect(event))
  })), /*#__PURE__*/React__default.createElement(ClickableContainer, _extends({}, getDataTaktAttributes({
    taktIdSuffix: `${id}_content`
  }), restProps, isClickable && {
    'aria-label': ariaLabel
  }, {
    as: getClickableContainerAs({
      href,
      onClick
    }),
    href: href,
    onClick: event => onClick === null || onClick === void 0 ? void 0 : onClick(event),
    $isClickable: isClickable
  }), /*#__PURE__*/React__default.createElement(CenterColumn, {
    id: `${id}_center_column`
  }, children), onClick && /*#__PURE__*/React__default.createElement(StyledIcon, {
    type: angleInlineEnd,
    size: "base"
  }))));
};

export { Content as C };
//# sourceMappingURL=Content-D32f6TK9.js.map
